import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useInstallPrompt } from "@/lib/pwa";

const DISMISS_KEY = "pwa-install-dismissed-at";
const DISMISS_DAYS = 14;

function recentlyDismissed() {
  try {
    const at = Number(localStorage.getItem(DISMISS_KEY));
    return at && Date.now() - at < DISMISS_DAYS * 864e5;
  } catch {
    return false;
  }
}

// Kartu ajakan "Pasang aplikasi" — muncul sekali tiap 14 hari bila browser mendukung instal.
export default function InstallPrompt() {
  const { canInstall, showIOSHint, promptInstall } = useInstallPrompt();
  const [ready, setReady] = useState(false);
  const [hidden, setHidden] = useState(recentlyDismissed);

  useEffect(() => {
    const t = setTimeout(() => setReady(true), 4000);
    return () => clearTimeout(t);
  }, []);

  if (!ready || hidden || !(canInstall || showIOSHint)) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* abaikan */ }
    setHidden(true);
  };
  const install = async () => {
    if (await promptInstall()) setHidden(true);
  };

  return (
    <div
      className="fixed z-[61] left-3 right-3 above-tabbar lg:left-auto lg:right-6 lg:w-96 animate-fade-up"
      role="dialog"
      aria-label="Pasang aplikasi"
      data-testid="pwa-install-prompt"
    >
      <div className="rounded-2xl bg-white border border-stone-soft shadow-2xl p-4 flex gap-3.5 items-start">
        <img src="/icon-192.png" alt="" className="w-12 h-12 rounded-xl shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-display font-semibold text-ink text-[15px] leading-snug">Pasang aplikasi Andalan Dapur</div>
          {canInstall ? (
            <p className="text-xs text-ink/60 mt-0.5">Buka lebih cepat dari layar utama, tanpa perlu ke Play Store.</p>
          ) : (
            <p className="text-xs text-ink/60 mt-0.5">
              Ketuk <Share size={13} className="inline -mt-0.5 text-forest" /> <b>Bagikan</b>, lalu pilih <b>Tambah ke Layar Utama</b>.
            </p>
          )}
          {canInstall && (
            <div className="flex gap-2 mt-3">
              <Button size="sm" onClick={install} className="rounded-full bg-forest hover:bg-forest-dark text-white" data-testid="pwa-install-button">
                <Download size={15} /> Pasang
              </Button>
              <Button size="sm" variant="ghost" onClick={dismiss} className="rounded-full text-ink/60">Nanti</Button>
            </div>
          )}
        </div>
        <button onClick={dismiss} className="p-1 -m-1 text-ink/45 hover:text-ink" aria-label="Tutup">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
